import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

// import "./mock/index.js"

import "../src/assets/css/reset.css"

import "./assets/js/rem.js"

import ElementUi from "element-ui"
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'v7ZMY6iGXd4jYRLbc3pqLs1zCdna3fKN'
})



Vue.use(dataV)
Vue.use(ElementUi)

import scroll from "vue-seamless-scroll";

import ECharts from 'echarts';

Vue.prototype.$ECharts = ECharts;
Vue.use(scroll)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
